import React, { useContext, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import StatsItem from 'components/assessments_pages/AssessmentStatsItem';
import RatingData from './RatingData';
import ControlArrows from './ControlArrows';

import styles from './styles';
import { statsCtx } from './statsStore';

const AssessmentStats = observer(({ classes, audition }) => {
    const {
        loading, statsArr, loadAssessmentStats,
        setLoading, setSlug, cleanStatsData,
        loadRatingData
    } = useContext(statsCtx);
    const { uuid, slug } = audition;

    useEffect(() => {
        setSlug(slug);
    }, [slug]);

    useEffect(() => {
        setLoading(true);
        loadAssessmentStats();
        loadRatingData();
        return () => cleanStatsData();
    }, []);

    const contentRef = useRef();

    return (
        <div className={classes.wrapper}>
            <div className={classes.statsWrapper}>
                <p className={classes.label}>Candidates</p>
                <div className={classes.contentWrapper}>
                    <ControlArrows left contentRef={contentRef} />
                    <div className={classes.content} ref={contentRef}>
                        {
                            loading ? (
                                <div className={classes.loaderWrapper}>
                                    <CircularProgress color="primary" size={25} className="u-mrg--tx2" />
                                </div>
                            ) : (
                                <>
                                    {statsArr.map((item, key) => <StatsItem isPercentageGrey key={key} {...item} />)}
                                </>
                            )
                        }
                    </div>
                    <ControlArrows right contentRef={contentRef} />
                </div>
            </div>
            <RatingData uuid={uuid} />
        </div>
    );
});

export default withStyles(styles)(withRouter(AssessmentStats));
